import { revalidateLogic, useForm } from '@tanstack/react-form'
import {
  obligacionRecurrenteSchema,
  DEFAULT_OBLIGACION_VALUES,
  type ObligacionRecurrenteFormValues,
} from './obligacionRecurrenteSchema'

export interface UseObligacionRecurrenteFormOptions {
  defaultValues?: Partial<ObligacionRecurrenteFormValues>
  onSubmit?: (data: ObligacionRecurrenteFormValues) => Promise<void> | void
}

export function useObligacionRecurrenteForm(options: UseObligacionRecurrenteFormOptions = {}) {
  const { defaultValues, onSubmit } = options

  const form = useForm({
    defaultValues: {
      ...DEFAULT_OBLIGACION_VALUES,
      ...defaultValues,
    } as ObligacionRecurrenteFormValues,
    // Valida al enviar y, después del primer intento, en cada cambio, así un error entre campos se limpia al corregir el otro campo.
    validationLogic: revalidateLogic(),
    validators: {
      onDynamic: ({ value }) => {
        const result = obligacionRecurrenteSchema.safeParse(value)
        if (!result.success) {
          return result.error.issues.map((issue) => ({
            message: issue.message,
            path: issue.path,
          }))
        }
        return undefined
      },
    },
    onSubmit: async ({ value }) => {
      if (onSubmit) {
        await onSubmit(value as ObligacionRecurrenteFormValues)
      }
    },
  })

  return { form }
}

export type UseObligacionRecurrenteFormReturn = ReturnType<typeof useObligacionRecurrenteForm>
export type ObligacionRecurrenteForm = UseObligacionRecurrenteFormReturn['form']
